export default "__VITE_ASSET__f8fd2c95__"